module.exports = __webpack_public_path__ + "img/61.ca3e7ef2.png";